import { render, staticRenderFns } from "./indexCp.vue?vue&type=template&id=938dbc90&scoped=true&"
import script from "./indexCp.vue?vue&type=script&lang=js&"
export * from "./indexCp.vue?vue&type=script&lang=js&"
import style0 from "./indexCp.vue?vue&type=style&index=0&id=938dbc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938dbc90",
  null
  
)

export default component.exports